import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Configuration from "../../Configuration";

/**
 * Class representing a select input.
 */
class Select extends React.Component
{
    static propTypes = {
        className: PropTypes.string,

        // Data to display in the list
        data: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        })),

        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

        // A placeholder simulation. In fact, add an option with "undefined" as value.
        placeholder: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func
    };

    static defaultProps = {
        data: [],
        disabled: false
    };

    /**
     * Triggered when the value change
     *
     * @param e The input event.
     */
    onChange = e => {
        const value = e.currentTarget.value;

        // If the placeholder value has been selected, returns undefined, else returns the selected value.
        this.props.onChange && this.props.onChange(value === "" ? undefined : value);
    };

    render() {
        const {className, data, value, placeholder, disabled} = this.props;
        const client = ("undefined" !== typeof Configuration.brand && Configuration.brand === "P" ? "ap digital-one":"");
        const disabledAp = disabled ?"disabled-ap":"";
        const classes = classNames("cccu-select",client,disabledAp, {[className]: className !== undefined});
        const classList = classNames("list-"+client);
        const selectClass=classNames("cccu-custom-select ",client," icon icon-arrow",disabledAp);
        return (
          <span className={selectClass}>
          {/*<div className={"digit-one-div-ap "+ client}></div>*/}
            <select id={className} value={value ? value : ""} className={classes} onChange={this.onChange} disabled={disabled}>
                {placeholder &&
                <option className={classList} value="">{placeholder}</option>
                }

                {data.map((v, k) =>
                    <option className={classList} key={k} value={v.value}>{v.label}</option>
                )}
            </select>
          </span>
        )
    }
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/widgets/Select.js